import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	routes: [{
			path: '/',
			redirect: '/index'
		},
		{
			path: '/',
			component: () => import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
			meta: {
				title: '自述文件'
			},
			children: [
				{
					path: '/index',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Index/Index.vue'),
					meta: {
						title: '系统首页'
					}
				},
				{
					path: '/account',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Account/Account.vue'),
					meta: {
						title: '账号管理'
					}
				},
				{
					path: '/role',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Role/Role.vue'),
					meta: {
						title: '职务管理'
					}
				},
				{
					path: '/menu',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Menu/Menu.vue'),
					meta: {
						title: '菜单管理'
					}
				},
				{
				path: '/instructor',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Instructor/Instructor.vue'),
					meta: {
						title: '教师管理'
					}
				},
				{
					path: '/classification',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Classification/Classification.vue'),
					meta: {
						title: '课程分类'
					}
				},
				{
					path: '/live-video',
					component: () => import( /* webpackChunkName: "table" */ '../pages/LiveVideo/LiveVideo.vue'),
					meta: {
						title: '直播管理'
					}
				},
				{
					path: '/live-user',
					component: () => import( /* webpackChunkName: "table" */ '../pages/LiveVideo/LiveUser.vue'),
					meta: {
						title: '直播签到管理'
					}
				},
				{
					path: '/semester',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Semester/Semester.vue'),
					meta: {
						title: '学期管理'
					}
				},
				{
					path: '/paycontrol',
					component: () => import( /* webpackChunkName: "table" */ '../pages/PayControl/PayControl.vue'),
					meta: {
						title: '缴费管理'
					}
				},
				{
					path: '/course',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Course/Course.vue'),
					meta: {
						title: '课程管理'
					}
				},
				{
					path: '/tution-course',
					// component: () => import( /* webpackChunkName: "table" */ '../components/page/CourseTution.vue'),
				    component: () => import( /* webpackChunkName: "table" */ '../pages/Tution/CourseTution.vue'),
				    meta: {
						title: '课程开课'
					}
				},
				{
					path: '/childManagement',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Site/ChildManagement.vue'),
					meta: {
						title: '子账号管理'
					}
				},
				{
					path: '/childManagementJX',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Site/ChildManagement.vue'),
					meta: {
						title: '招生人员账号管理'
					}
				},{
					path: '/site',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Site/Site.vue'),
					meta: {
						title: '函授站点'
					}
				},{
					path: '/siteJX',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Site/Site.vue'),
					meta: {
						title: '招生人员管理'
					}
				},
				{
					path: '/relativities',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Relativities/Relativities.vue'),
					meta: {
						title: '学生信息库'
					}
				},
				{
					path: '/admission',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Admission/Admission.vue'),
					meta: {
						title: '录取管理'
					}
				},
				{
					path: '/user',
					component: () => import( /* webpackChunkName: "table" */ '../pages/User/User.vue'),
					meta: {
						title: '用户管理'
					}
				},
				{
					path: '/text',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Text/Text.vue'),
					meta: {
						title: '文本管理'
					}
				},
				{
					path: '/question',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Question/QuestionBank.vue'),
					meta: {
						title: '题库管理'
					}
				},
				{
					path: '/student',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Student/StudentManagement.vue'),
					meta: {
						title: '学生管理'
					}
				},
				{
					path: '/transition',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Transition/TransitionManagement.vue'),
					meta: {
						title: '转换值'
					}
				},
				{
					path: '/organization',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Organization/Organization.vue'),
					meta: {
						title: '院校管理'
					}
				},
				{
					path: '/major',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Major/Major.vue'),
					meta: {
						title: '专业管理'
					}
				},
				{
					path: '/task',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Task/Task.vue'),
					meta: {
						title: '任务管理'
					}
				},
				{
					path: '/teach',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Teach/Teach.vue'),
					meta: {
						title: '一键开课'
					}
				},
				{
					path: '/TemplatePage',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/TemplatePage/TemplatePage.vue'),
					meta: {
						title: '模板'
					}
				},
				{
					path: '/notice',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Notice/Notice.vue'),
					meta: {
						title: '通知公告'
					}
				},
				{
					path: '/arrangement',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Arrangement/Arrangement.vue'),
					meta: {
						title: '排课管理'
					}
				},
				{
					path: '/exam',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Exam/Exam.vue'),
					meta: {
						title: '考务管理'
					}
				},
				{
					path: '/result',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Result/Result.vue'),
					meta: {
						title: '成绩管理'
					}
				},
				{
					path: '/studentResult',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Result/StudentResult.vue'),
					meta: {
						title: '学生成绩'
					}
				},
				{
					path: '/resultMsg',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Result/ResultMsg.vue'),
					meta: {
						title: '学生成绩'
					}
				},
				{
					path: '/courseResult',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Result/CourseResult.vue'),
					meta: {
						title: '课程成绩'
					}
				},
				{
					path: '/thesis',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Thesis/Thesis.vue'),
					meta: {
						title: '毕业实践报告'
					}
				},
				{
					path: '/studentThesis',
					component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Thesis/StudentThesis.vue'),
					meta: {
						title: '学生论文'
					}
				},
				{
				   path: '/courseResult',
				   component: () => import( /* webpackChunkName: "dashboard" */ '../pages/Result/CourseResult.vue'),
				   meta: {
				      title: '课程成绩'
				   }
				},
				{
					path: '/graduatepre',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Graduate/GraduatePre.vue'),
					meta: {
						title: '预毕业名单'
					}
				},
				{
					path: '/prespecific',
					name:'prespecific',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Graduate/PreSpecific.vue'),
					meta: {
						title: '预毕业信息'
					}
				},
				{
					path: '/graduateroll',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Graduate/GraduateRoll.vue'),
					meta: {
						title: '毕业名单'
					}
				},
				{
					path: '/rollspecific',
					name:'rollspecific',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Graduate/RollSpecific.vue'),
					meta: {
						title: '毕业信息'
					}
				},
				{
					path: '/graduatecheck',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Graduate/GraduateCheck.vue'),
					meta: {
						title: '资料审核名单'
					}
				},
				{
					path: '/checkspecific',
					name:'checkspecific',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Graduate/CheckSpecific.vue'),
					meta: {
						title: '资料审核信息'
					}
				},
				{
					path: '/preStudent',
					name:'PreStudent',
					component: () => import( /* webpackChunkName: "table" */ '../pages/PrepExam/PreStudent.vue'),
					meta: {
						title: '学生管理'
					}
				},
				{
					path: '/preJxStudent',
					name:'PreJxStudent',
					component: () => import( /* webpackChunkName: "table" */ '../pages/PrepExam/PreJxStudent.vue'),
					meta: {
						title: '预报名管理'
					}
				},
				{
					path: '/preGZStudent',
					name:'PreGZStudent',
					component: () => import( /* webpackChunkName: "table" */ '../pages/PrepExam/PreGZStudent.vue'),
					meta: {
						title: '学生录入'
					}
				},
				{
					path: '/learningProgress',
					name:'LearningProgress',
					component: () => import( /* webpackChunkName: "table" */ '../pages/PrepExam/LearningProgress.vue'),
					meta: {
						title: '学习进度'
					}
				},
				{
					path: '/curriculumSetting',
					name:'CurriculumSetting',
					component: () => import( /* webpackChunkName: "table" */ '../pages/PrepExam/CurriculumSetting.vue'),
					meta: {
						title: '课程设置'
					}
				},
				{
					path: '/systemConfig',
					name:'SystemConfig',
					component: () => import( /* webpackChunkName: "table" */ '../pages/SystemConfig/SystemConfig.vue'),
					meta: {
						title: '系统配置'
					}
				},
				{
					path: '/partner',
					name:'Partner',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Partner/Partner.vue'),
					meta: {
						title: '合作方管理'
					}
				},
				{
					path: '/reportCheck',
					name:'reportCheck',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Graduate/reportCheck.vue'),
					meta: {
						title: '报告管理'
					}
				},
				{
					path: '/studentReport',
					name:'studentReport',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Graduate/studentReport.vue'),
					meta: {
						title: '学生报告'
					}
				},
				{
					path: '/belowpartner',
					component: () => import( /* webpackChunkName: "table" */ '../pages/BelowPartner/BelowPartner.vue'),
					meta: {
						title: '子账号管理'
					}
				},
				{
					path: '/partnerRole',
					name:'partnerRole',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Partner/Role/Role.vue'),
					meta: {
						title: '职务管理'
					}
				},
				{
					path: '/studenInfo',
					name:'studenInfo',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Organization/studenInfo.vue'),
					meta: {
						title: '账号增删记录'
					}
				},
				{
					path: '/operateRecord',
					name:'operateRecord',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Organization/operateRecord.vue'),
					meta: {
						title: '财务明细'
					}
				},
				{
					path: '/specialCourse',
					name:'specialCourse',
					component: () => import( /* webpackChunkName: "table" */ '../pages/SpecialCourse/Course.vue'),
					meta: {
						title: '课程查看'
					}
				},
				{
					path: '/specialQues',
					name:'specialQues',
					component: () => import( /* webpackChunkName: "table" */ '../pages/SpecialQues/QuestionBank.vue'),
					meta: {
						title: '题库查看'
					}
				},
				{
					path: '/TeacherSatisfaction',
					name:'TeacherSatisfaction',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Questionnaire/TeacherSatisfaction.vue'),
					meta: {
						title: '教师教学满意度'
					}
				},
				{
					path: '/StudentTeaching',
					name:'StudentTeaching',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Questionnaire/StudentTeaching.vue'),
					meta: {
						title: '学生教学满意度'
					}
				},
				{
					path: '/StudentCourses',
					name:'StudentCourses',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Questionnaire/StudentCourses.vue'),
					meta: {
						title: '学生课程满意度'
					}
				},
				{
					path: '/TeacherEducation',
					name:'TeacherEducation',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Questionnaire/TeacherEducation.vue'),
					meta: {
						title: '继教院评价'
					}
				},
				{
					path: '/TeacherStudent',
					name:'TeacherStudent',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Questionnaire/TeacherStudent.vue'),
					meta: {
						title: '教师评学综合评价'
					}
				},
				{
					path: '/SatisfactionIndex',
					name:'SatisfactionIndex',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Questionnaire/SatisfactionIndex.vue'),
					meta: {
						title: '数据统计'
					}
				},
				{
					path: '/noticeplatform',
					name:'noticeplatform',
					component: () => import( /* webpackChunkName: "table" */ '../pages/Notice/NoticePlatform.vue'),
					meta: {
						title: '平台通知'
					}
				},
				{
					path: '/exterbal',
					name:'exterbal',
					component: () => import( /* webpackChunkName: "table" */ '../pages/PrepExam/Exterbal.vue'),
					meta: {
						title: '外部表单'
					}
				},
				{
					path: '/degreeeEnglish',
					name:'degreeeEnglish',
					component: () => import( /* webpackChunkName: "table" */ '../pages/DegreeeEnglish/DegreeeEnglish.vue'),
					meta: {
						title: '资料审核'
					}
				},
				{
					path: '/degreeeExam',
					name:'degreeeExam',
					component: () => import( /* webpackChunkName: "table" */ '../pages/DegreeeEnglish/DegreeeExam.vue'),
					meta: {
						title: '学位考试'
					}
				},
				{
					path: '/degreeeExamArea',
					name:'degreeeExamArea',
					component: () => import( /* webpackChunkName: "table" */ '../pages/DegreeeEnglish/DegreeeExanArea.vue'),
					meta: {
						title: '考区设置'
					}
				},
				{
					path: '/degreeeTicket',
					name:'degreeeTicket',
					component: () => import( /* webpackChunkName: "table" */ '../pages/DegreeeEnglish/DegreeeTicket.vue'),
					meta: {
						title: '准考证设置'
					}
				},
			]
		},
		{
			path: '/login',
			component: () => import( /* webpackChunkName: "login" */ '../pages/Login/Login.vue'),
			meta: {
				title: '登录'
			}
		},
		{
			path: '*',
			redirect: '/404'
		},
		// {
		// 	path: '/create-question',
		// 	component: () => import( /* webpackChunkName: "login" */ '../pages/Question/CreateQuestion.vue'),
		// 	meta: {
		// 		title: '创建试题'
		// 	}
		// },
		{
			path: '/editQuestion',
			component: () => import( /* webpackChunkName: "login" */ '../pages/Question/editQuestion.vue'),
			meta: {
				title: '创建试题'
			}
		},
		{
			path: '/topicPreview',
			component: () => import( /* webpackChunkName: "403" */ '../pages/Question/topicPreview.vue'),
			meta: {
				title: '预览'
			}
		}
	]
});
